import ReactToPrint from "react-to-print";
import { PrintIcon, XButton } from "../../assets/icons/icons";
import theme from "../../theme";
import styled from "@emotion/styled";

const { md, lg } = theme.screen;

type Prop = {
  onClose: () => void;
  printAreaComponentRef: React.RefObject<HTMLDivElement>;
};

// 프린트 영역 바깥에 존재해야하는 상호작용 버튼들
export const CloseAndPrintButtons = ({
  onClose,
  printAreaComponentRef,
}: Prop) => {
  return (
    <>
      {/* 닫기 버튼 */}
      <XButtonContainer
        onClick={() => {
          onClose();
        }}
      >
        <XButton />
      </XButtonContainer>

      {/* 프린트 버튼 */}
      <ReactToPrint
        trigger={() => (
          <PdfButtonStyledButton>
            {/* 리포트 PDF 다운로드 */}
            <PrintIcon
              width="30px"
              height="30px"
              fill={theme.color.neutral_400}
            />
          </PdfButtonStyledButton>
        )}
        content={() => printAreaComponentRef.current}
      />
    </>
  );
};

const XButtonContainer = styled.div`
  position: absolute;
  top: 12px;
  right: 10px;
  color: ${theme.color.neutral_400};
  z-index: 100;

  @media (max-width: ${md}px) {
    background-color: ${theme.color.white};
    height: 45px;
    top: 0px;
    border-top-right-radius: 10px;
    display: flex;
    align-items: center;
    svg {
      width: 30px;
      height: 30px;
    }
  }
`;

const PdfButtonStyledButton = styled.button`
  background: transparent;
  color: ${theme.color.neutral_400};
  border: none;
  cursor: pointer;
  transition: 200ms;
  &:hover {
    scale: 110%;
  }
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 100;

  @media (max-width: ${lg}px) {
    display: none;
  }
`;
